module.exports = [
  {
    unique_name: 'overallRating',
    ratingType: 'starRating',
    label: 'ratingLabel',
  },
  
];
